<ng-template #dashboardConfigTemplate>
  <form *ngIf="!loading" [formGroup]="form">
    <div class="form-row">
      <div class="col">
        <mat-form-field class="full-width">
          <mat-label>Window</mat-label>
          <mat-select formControlName="window">
            <mat-option *ngFor="let w of possibleWindows" [value]="w">{{ w }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </form>
  Showing plots for:
  <br />
  Start: {{ windowStart | momentPipe }} <br />
  End: {{ windowEnd | momentPipe }}
</ng-template>

<ng-template #dashboardTemplate>
  <div class="row">
    <div class="col">
      <app-all-usage [usage]="usage | async" [window]="window?.value"></app-all-usage>
    </div>
  </div>
</ng-template>

<div *ngIf="loadingInProgress$ | async" class="d-flex justify-content-center">
  <app-progress-spinner></app-progress-spinner>
</div>
<div [hidden]="loadingInProgress$ | async">
  <app-analytics-dashboard
    [dashboardConfigTemplate]="dashboardConfigTemplate"
    [dashboardTemplate]="dashboardTemplate"
    [lastRefreshTime]="lastRefreshTime | async"
  >
  </app-analytics-dashboard>
</div>
